import QuoteList from "../modules/quote_table/quote_list"
import delayparams from "../modules/url/delayQuote"
import Param from "../modules/public_fun/param"
import { formatNumToFixed, dealData, drawGoldChart, countCommonData } from "./draw_gold_chart"
import GoldBankList from "../modules/quote_table/list_gold_bank"
import PhysicalGoldList from "../modules/quote_table/list_gold"

let quote_api_host = "//push2.eastmoney.com"

if (Param.get("env") == "test") {
  quote_api_host = "//push2test.eastmoney.com"
}

declare var Swiper

let data = {
  newclass: null,
  timer: null,
  pz_size: 10,
  quoteConfig: {
    host: "//push2.eastmoney.com",
    kline_host: "//push2his.eastmoney.com",
    datacenter_host: "//datacenter.eastmoney.com",
    datacenter_path: "/securities/api/data/v1/get",
    kline_path: "/api/qt/stock/kline/get",
    uPath: "/api/qt/stock/get",
    unpPath: "/api/qt/ulist.np/get",
    token: "f057cbcbce2a86e2866ab8877db1d059",
    cPath: "/api/qt/clist/get",
  },
  bank_icon: {
    建设银行龙鼎金条: "icon_jianshe_bank",
    中国银行金条: "icon_cn_bank",
    工商银行如意金条: "icon_gongshang_bank",
    农行传世之宝金条: "icon_nongye_bank",
    和谐平安金条: "icon_pingan_bank",
    浦发银行投资金条: "icon_pufa_bank",
  },
  gold_store_icon: {
    周大福: "icon_zdf_gold",
    周六福: "icon_zlf_gold",
    周生生: "icon_zss_gold",
    周大生: "icon_zds_gold",
    潮宏基: "icon_chj_gold",
    六福珠宝: "icon_lfzb_gold",
    老凤祥: "icon_lfx_gold",
    老庙黄金: "icon_lmhj_gold",
    中国黄金: "icon_zghj_gold",
  },
  currentGoldNavItem: "sh_gold",
  refresh_time: 10,
  gold_chart: null,
  spread_chart: null,
  currency: null,
  XAU_Data: null,
  SH_AU_Data: null,
  XAU_CNY: null, // 人民币计价的伦敦金
  gold_spread: null, // 价差
  // 初始化
  init: function () {
    let self = this
    self.getData(self.getGoldIndex(), self.bindSwiperData)
    self.getGoldMonthZDF()
    self.bindGoldComponent()
    self.drawGoldChart()
    if (self.refresh_time > 0) {
      clearInterval(self.timer)
      self.timer = setInterval(() => {
        self.refresh()
      }, self.refresh_time * 1000)
    }
    self.list2 = self.makeGoldQuoteList()
    self.getXAUCurrencyData()
    self.makeGoldBankList()
    self.makePhysicalGoldList()

    $(".hsphb-more").on("click", async function () {
      try {
        let data = await self.table.showMore(20)
        self.pz_size += 20
        let dataNum = data.data.diff.length
        if (self.pz_size > dataNum) {
          $(".hsphb-more").html("已经到底了")
        }
      } catch (error) {
        $(".hsphb-more").html("暂无数据")
      }
    })
  },
  // 获取黄金相关指数
  getGoldIndex: function () {
    let self = this
    let ids = "101.GC00Y,122.XAU,118.AUTD,118.SHAU,100.UDI"
    let url = quote_api_host + self.quoteConfig.unpPath + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids + "&ut=" + self.quoteConfig.token + "&forcect=1" + delayparams
    return url
  },
  // 获取黄金现货近一月涨跌幅
  getGoldMonthZDF: function () {
    let self = this
    let url = quote_api_host + self.quoteConfig.uPath + "?fltt=2&invt=2&fields=f120,f152&secid=118.SHAU" + "&ut=" + self.quoteConfig.token + "&forcect=1&dect=0" + delayparams
    self.getData(url, (data, self) => {
      if (data) {
        let result = data?.data
        $("#sh_gold_zdf").html(formatNumToFixed(result.f120, 0, result.f152, "", "%"))
        $("#sh_gold_zdf").addClass(self.formatColor(result.f120))
      }
    })
  },
  getGoldHotPoint: function (options, data) {
    let self = this
    let common_data = countCommonData(options, data)
    let current_price = data?.klines[data?.klines?.length - 1].close
    let { high_price, low_price } = common_data
    let price_rate = parseFloat(((high_price - current_price) / (high_price - low_price)).toFixed(3)) ?? 0

    $("#sh_gold_hot_point").html(self.getHotPointTitle(1 - price_rate))
    let _span = $(`.gold-market-hot`).find("span")
    _span[0].style.flex = `${1 - price_rate}`
    if (price_rate == 0) {
      _span[0].style.borderRadius = `0.25rem`
    }
    _span[1].style.flex = `${price_rate}`
  },
  getHotPointTitle: function (rate) {
    if (rate >= 0 && rate < 0.2) {
      return "冰点"
    } else if (rate >= 0.2 && rate < 0.35) {
      return "过冷"
    } else if (rate >= 0.35 && rate < 0.5) {
      return "微冷"
    } else if (rate >= 0.5 && rate < 0.65) {
      return "微热"
    } else if (rate >= 0.65 && rate < 0.8) {
      return "过热"
    } else if (rate >= 0.8 && rate <= 1) {
      return "沸点"
    } else {
      return "-"
    }
  },
  // 获取K线相关数据
  getKLineData: function (quotecode) {
    let self = this
    let url = `${self.quoteConfig.kline_host + self.quoteConfig.kline_path}?cb=?`
    return $.ajax({
      url: url,
      type: "get",
      data: {
        fltt: 2,
        invt: 2,
        fqt: 2,
        forcect: 2,
        ut: self.quoteConfig.token,
        beg: self.getLastYearDate(),
        end: 20500000,
        secid: quotecode,
        klt: 101,
        fields1: "f1,f2,f3,f4,f5,f6,f7,f8,f120",
        fields2: "f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61,f62,f63,f64,f65",
      },
      dataType: "jsonp",
    })
  },
  // Ajax 请求
  getData: function (url, callback) {
    let self = this
    $.ajax({
      url: url,
      type: "get",
      dataType: "json",
      success: function (data) {
        //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
        callback(data, self)
      },
    })
  },
  bindGoldComponent: function () {
    let self = this
    let timer: any = null
    const goldArr = document.querySelectorAll(".hq-gold-nav-item")
    goldArr.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault()
        const targetId = this.getAttribute("data-target")
        document.querySelectorAll(".hq-gold-content-item").forEach((component) => {
          component.classList.remove("content-active")
        })
        document.querySelectorAll(".hq-gold-nav-item").forEach((nav) => {
          nav.classList.remove("nav-item-active")
        })

        const targetComponent = document.getElementById(targetId)
        if (targetComponent) {
          if (targetId == "gold_spread") {
            self.getXAUCurrencyData()
            timer && clearTimeout(timer)
            timer = setTimeout(() => {
              self.drawSpreadChart()
              timer && clearTimeout(timer)
            }, 200)
          } else {
            self.drawGoldChart()
          }
          targetComponent.classList.add("content-active")
          item.classList.add("nav-item-active")
          self.currentGoldNavItem = targetId
        }
      })
      // item.removeEventListener()
    })
  },
  getXAUCurrencyData() {
    let self = this
    self
      .getKLineData("121.USDCNYI")
      .then((data) => {
        let temp = dealData(data)
        temp && (self.currency = temp)
      })
      .then(() => {
        self.getKLineData("122.XAU").then((data) => {
          let temp = dealData(data)
          if (temp) {
            self.XAU_Data = temp
            self.calculateXAU_Data()
          }
        })
      })
  },
  calculateXAU_Data() {
    let self = this
    let XAU_CNY: any = []
    let cur_data = self.currency?.klines ?? []
    let xau_data = self.XAU_Data?.klines ?? []
    let last_close = 0

    xau_data.map((v: any) => {
      let cur = cur_data.find((v1) => v1.date == v.date)
      if (cur) {
        XAU_CNY.push({ date: v.date, close: ((v.close * cur.close) / 31.1035).toFixed(2), zde: v.zde })
        last_close = cur.close
      } else {
        XAU_CNY.push({ date: v.date, close: ((v.close * last_close) / 31.1035).toFixed(2), zde: v.zde })
      }
    })
    let XAU_Data = {
      name: "伦敦金",
      decimal: 2,
      klines: XAU_CNY.filter((v) => v.close != 0),
    }
    self.XAU_Data = XAU_Data
    self.getGoldSpread(self.SH_AU_Data, XAU_Data)
  },
  getGoldSpread(SHAU_Data, XAU_Data) {
    let self = this
    let last_sh_close = 0

    if (SHAU_Data?.klines?.length && XAU_Data?.klines?.length) {
      const shauMap = SHAU_Data.klines.reduce((map, v) => {
        map[v.date] = v.close
        return map
      }, {})

      const gold_spread = XAU_Data.klines.reduce((spread, v, index) => {
        const shauClose = shauMap[v.date]
        const close = shauClose ? (shauClose - v.close).toFixed(2) : (last_sh_close - v.close).toFixed(2)

        // if(v.close != 0 && shauClose != 0){
        spread.push({ date: v.date, close })
        // }

        last_sh_close = shauClose || last_sh_close
        if (!shauMap[v.date]) {
          SHAU_Data.klines.splice(index, 0, { date: v.date, close: last_sh_close })
        }
        return spread
      }, [])
      let current_spread = gold_spread[gold_spread.length - 1].close
      $("#sh_gold_spread").html(current_spread)
      $("#sh_gold_spread").addClass(self.formatColor(current_spread))
      self.gold_spread = gold_spread
    }
  },
  drawSpreadChart: function () {
    let self = this
    let Gold_Spread_Data = {
      name: "价差",
      klines: self.gold_spread,
      decimal: 2,
    }
    let multiData = {
      SHAU_Data: self.SH_AU_Data,
      XAU_Data: self.XAU_Data,
      Gold_Spread_Data,
    }
    let container = document.getElementById("gold_spread")
    if (self.gold_spread && multiData && container) {
      self.spread_chart && self.spread_chart.destroy()
      let spreadChart = new drawGoldChart({
        container,
        kline_data: multiData,
        width: $("#gold_spread").width()!,
        height: 260,
        fontsize: 12,
        type: "gold_spread",
      })
      self.spread_chart = spreadChart
      spreadChart.draw()
      $(".sh_gold_chart").on("click", function () {
        window.location.href = "/quote/gold_spread.html"
      })
    }
  },
  // 给 Swiper 绑定数据
  bindSwiperData: function (data, self) {
    if (data.rc == 0) {
      let _class = ""
      let _siwper_html = ""
      data.data.diff.forEach((item, index) => {
        if (index == 0) {
          _class = "swiper-slide swiper-slide-active"
        } else if (index == 1) {
          _class = "swiper-slide swiper-slide-next"
        } else {
          _class = "swiper-slide"
        }
        _siwper_html += `<div class="${_class}">
                            <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p style="font-weight:bold">${item.f14}</p>
                                    <p class='${item.f4 > 0 ? "gp-asc" : item.f4 < 0 ? "gp-des" : ""}'>${self.numberFix(item.f2, 2)}</p>
                                    <p class='${item.f4 > 0 ? "gp-asc" : item.f4 < 0 ? "gp-des" : ""}'>
                                        <span>${self.numberFix(item.f4, 2)}</span>
                                        <span>${self.dataProcess(item.f3, "%")}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
      })
      $("#gold").html(_siwper_html)
      let swiper = new Swiper(".gold-swiper", {
        direction: "horizontal",
        slidesPerGroup: 3,
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".go-nuxt",
          prevEl: ".go-pre",
        },
      })
    }
  },
  // Swiper 数据刷新
  refreshSwiperData: function (data, self) {
    let _dom = $("#gold").find(".swiper-slide")
    if (data.rc == 0) {
      data.data.diff.forEach((item, index) => {
        _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p style="font-weight:bold">${item.f14}</p>
                    <p class='${item.f4 > 0 ? "gp-asc" : item.f4 < 0 ? "gp-des" : ""}'>${self.numberFix(item.f2, 2)}</p>
                    <p class='${item.f4 > 0 ? "gp-asc" : item.f4 < 0 ? "gp-des" : ""}'>
                        <span>${self.numberFix(item.f4, 2)}</span>
                        <span>${self.dataProcess(item.f3, "%")}</span>
                    </p>
                </a>
            </div>`
      })
    }
  },
  // 页面自刷
  refresh: function () {
    let self = this
    let url = self.getGoldIndex()
    self.getData(url, self.refreshSwiperData)
  },
  drawGoldChart: function () {
    let self = this
    self.getKLineData("118.SHAU").then((data) => {
      let backdata = dealData(data)
      let container = document.getElementById(self.currentGoldNavItem)
      if (backdata && container) {
        self.SH_AU_Data = backdata
        let options = {
          container,
          kline_data: backdata,
          width: $("#sh_gold").width()!,
          height: 260,
          fontsize: 12,
          type: self.currentGoldNavItem,
        }
        self.getGoldHotPoint(options, backdata)
        self.gold_chart && self.gold_chart.destroy()
        let goldChart = new drawGoldChart(options)
        self.gold_chart = goldChart
        goldChart.draw()
        $("#sh_gold").on("click", function () {
          window.location.href = "/quote/stock/118.SHAU.html"
        })
      }
    })
  },
  makeGoldQuoteList: function () {
    let self = this
    let quoteList2 = new QuoteList({
      ele: "gold-list",
      tabconfig: {
        tabitem: [
          {
            name: "gnxh",
            title: "国内现货",
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fid0=f4001&fs=b:MK0869&fields=f2,f3,f4,f12,f13,f14,f19,f3,f111,f148${delayparams}`,
            body: [
              {
                name: "info",
                title: "名称",
                html: function (data) {
                  return `<div><p>${data.f14}</p><p>${data.f12}</p></div>`
                },
              },
              {
                name: "xj",
                title: "最新",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.numberFix(data.f2, 2)}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.numberFix(data.f2, 2)}</div>`
                  } else {
                    result = `<div>${self.numberFix(data.f2, 2)}</div>`
                  }
                  return result
                },
              },
              {
                name: "zf",
                title: "涨幅",
                html: function (data) {
                  let result = ""
                  if (data.f3 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f3, "%")}</div>`
                  } else if (data.f3 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f3, "%")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f3, "%")}</div>`
                  }
                  return result
                },
              },
              {
                name: "zde",
                title: "涨跌",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f4, "")}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f4, "")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f4, "")}</div>`
                  }
                  return result
                },
              },
            ],
            noData: function (data) {
              return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
            },
          },
          {
            name: "gnqh",
            title: "国内期货",
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=0&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fid0=f4001&fs=b:MK0870&fields=f2,f3,f4,f12,f13,f14,f19,f111,f3,f148`,
            body: [
              {
                name: "info",
                title: "名称",
                html: function (data) {
                  return `<div><p>${data.f14}</p><p>${data.f12}</p></div>`
                },
              },
              {
                name: "xj",
                title: "最新",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.numberFix(data.f2, 2)}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.numberFix(data.f2, 2)}</div>`
                  } else {
                    result = `<div>${self.numberFix(data.f2, 2)}</div>`
                  }
                  return result
                },
              },
              {
                name: "zf",
                title: "涨幅",
                html: function (data) {
                  let result = ""
                  if (data.f3 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f3, "%")}</div>`
                  } else if (data.f3 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f3, "%")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f3, "%")}</div>`
                  }
                  return result
                },
              },
              {
                name: "zde",
                title: "涨跌",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f4, "")}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f4, "")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f4, "")}</div>`
                  }
                  return result
                },
              },
            ],
            noData: function (data) {
              return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
            },
          },
          {
            name: "gjxh",
            title: "国际现货",
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fid0=f4001&fs=b:MK0872&fields=f2,f3,f4,f6,f8,f10,f12,f13,f14,f19,f3,f111,f148`,
            body: [
              {
                name: "info",
                title: "名称",
                html: function (data) {
                  return `<div><p>${data.f14}</p><p>${data.f12}</p></div>`
                },
              },
              {
                name: "xj",
                title: "最新",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.numberFix(data.f2, 2)}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.numberFix(data.f2, 2)}</div>`
                  } else {
                    result = `<div>${self.numberFix(data.f2, 2)}</div>`
                  }
                  return result
                },
              },
              {
                name: "zf",
                title: "涨幅",
                html: function (data) {
                  let result = ""
                  if (data.f3 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f3, "%")}</div>`
                  } else if (data.f3 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f3, "%")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f3, "%")}</div>`
                  }
                  return result
                },
              },
              {
                name: "zde",
                title: "涨跌",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f4, "")}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f4, "")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f4, "")}</div>`
                  }
                  return result
                },
              },
            ],
            noData: function (data) {
              return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
            },
          },
          {
            name: "gjqh",
            title: "国际期货",
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fid0=f4001&fs=b:MK0871&fields=f2,f3,f4,f6,f8,f10,f12,f13,f14,f19,f3,f111,f148`,
            body: [
              {
                name: "info",
                title: "名称",
                html: function (data) {
                  return `<div><p>${data.f14}</p><p>${data.f12}</p></div>`
                },
              },
              {
                name: "xj",
                title: "最新",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.numberFix(data.f2, 2)}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.numberFix(data.f2, 2)}</div>`
                  } else {
                    result = `<div>${self.numberFix(data.f2, 2)}</div>`
                  }
                  return result
                },
              },
              {
                name: "zf",
                title: "涨幅",
                html: function (data) {
                  let result = ""
                  if (data.f3 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f3, "%")}</div>`
                  } else if (data.f3 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f3, "%")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f3, "%")}</div>`
                  }
                  return result
                },
              },
              {
                name: "zde",
                title: "涨跌",
                html: function (data) {
                  let result = ""
                  if (data.f4 > 0) {
                    result = `<div class='shares-rise'>${self.dataProcess(data.f4, "")}</div>`
                  } else if (data.f4 < 0) {
                    result = `<div class='shares-fall'>${self.dataProcess(data.f4, "")}</div>`
                  } else {
                    result = `<div>${self.dataProcess(data.f4, "")}</div>`
                  }
                  return result
                },
              },
            ],
          },
        ],
      },
      refresh: 15,
    })
    quoteList2.init()

    return quoteList2
  },
  makePhysicalGoldList: function () {
    let self = this
    let List1 = new PhysicalGoldList({
      ele: "physical-gold",
      api: `${
        self.quoteConfig.datacenter_host + self.quoteConfig.datacenter_path
      }?reportName=RPT_PHYSICAL_GOLD_LIST&columns=REPORT_DATE,PUBLISH_DATE,PRICE,BRAND_NAME,JEWELRY_NAME,UNIT,CHANGE_NAME,PURITY,LABOUR_PRICE,BRAND_NUM,JEWELRY_NUM,TYPE_CODE,TYPE_NAME,JEWELRY_NAME_SEC,PRICE_SEC,UNIT_SEC,JEWELRY_NAME_THR,PRICE_THR,UNIT_THR,CHANGE_NAME_SEC,CHANGE_NAME_THR&quoteColumns=&filter=(TYPE_CODE="001")&pageNumber=1&pageSize=9&sortTypes=1&sortColumns=BRAND_NUM&source=securities&client=wap`,
      refresh: 15,
      html: function (data) {
        return `
            <li>
                <div class="gold-store-name">
                  <i class=${self.gold_store_icon[data.BRAND_NAME]}></i>
                  <span class="physical-gold-name">${data.BRAND_NAME}</span>
                </div>
                <div class="physical-gold-price ${data.CHANGE_NAME == "涨" ? "red" : data.CHANGE_NAME == "跌" ? "green" : ""}">
                  ${formatNumToFixed(data.PRICE, 0, 2)}
                </div>
                <div class="physical-gold-sec">
                  <p> ${data.JEWELRY_NAME_SEC}</p>
                  <p class="physical-gold-price-sec">
                    ${formatNumToFixed(data.PRICE_SEC, 0, 2)}
                  </p>
                </div>
            </li>
            `
      },
    })
    List1.init()
  },
  makeGoldBankList: function () {
    let self = this
    let List1 = new GoldBankList({
      ele: "bank-gold",
      api: `${
        self.quoteConfig.datacenter_host + self.quoteConfig.datacenter_path
      }?reportName=RPT_PHYSICAL_GOLD_LIST&columns=REPORT_DATE,PUBLISH_DATE,PRICE,BRAND_NAME,JEWELRY_NAME,UNIT,CHANGE_NAME,PURITY,LABOUR_PRICE,BRAND_NUM,JEWELRY_NUM,TYPE_CODE,TYPE_NAME,INDICATOR_ID,INDICATOR_NAME&quoteColumns=&filter=(TYPE_CODE="002")&pageNumber=1&pageSize=6&sortTypes=1,1&sortColumns=BRAND_NUM,JEWELRY_NUM&source=securities&client=wap`,
      // refresh: 15,
      html: function (data) {
        return `
            <dd>
              <div>
                <p style=${data.JEWELRY_NAME.length > 6 ? "font-size:1.3rem" : ""}><i class=${self.bank_icon[data.JEWELRY_NAME]}></i><span class="gold-bank-name">${data.JEWELRY_NAME}</span></p>
                </div>
                <div style="font-weight:bold">${data.PRICE}</div>
            </dd>
            `
      },
    })
    List1.init()
  },
  conversion(num: number, isSign: boolean, isUnit: boolean) {
    let numSign: string
    let self = this
    if (isSign) {
      if (num < 0) {
        numSign = "-"
      } else if (num == 0) {
        numSign = ""
      } else {
        numSign = ""
      }
    } else {
      numSign = ""
    }
    if (Math.abs(num) == 0) {
      return 0
    } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
      return numSign + self.numberFix(Math.abs(num), 3)
    } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
      return numSign + self.numberFix(Math.abs(num), 2)
    } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
      return numSign + self.numberFix(Math.abs(num), 1)
    } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
      return numSign + self.numberFix(Math.abs(num), 0)
    } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 10000, 2) + "万"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 10000, 2)
      }
    } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 10000, 1) + "万"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 10000, 1)
      }
    } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 10000, 0) + "万"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 10000, 0)
      }
    } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + "亿"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
      }
    } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + "亿"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
      }
    } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + "亿"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
      }
    } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + "万亿"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
      }
    } else if (Math.abs(num) >= 10000000000000) {
      if (isUnit) {
        return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + "万亿"
      } else {
        return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
      }
    } else {
      return "-"
    }
  },
  numberFix(num: number, n: number) {
    var f = parseFloat(String(num))
    if (isNaN(f)) {
      return "-"
    }
    var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
    if (n == 0) {
      return f
    } else {
      var s = f.toString()
      var rs = s.indexOf(".")
      if (rs < 0) {
        rs = s.length
        s += "."
      }
      while (s.length <= rs + n) {
        s += "0"
      }
      return s
    }
  },
  dataProcess(data, symbol) {
    let self = this
    if (data == undefined || data == null || data == "-") {
      return "-"
    } else {
      return self.numberFix(data, 2) + symbol
    }
  },
  getLastYearDate() {
    const currentDate = new Date()
    // 获取当前日期往前一年的日期
    const lastYearDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate())
    const formattedDate = lastYearDate.toISOString().slice(0, 10)
    return formattedDate.split("-").join("")
  },
  formatColor(value: any) {
    if (value == "-" || isNaN(Number(value)) || value == null) return ""

    if (value.toString().indexOf("-") > -1) {
      return "green"
    } else if (value == 0) {
      return "gray"
    } else {
      return "red"
    }
  },
}

data.init()

import { NavScroll } from "../modules/title_scroll"
NavScroll("nav_gold")
